import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap';

export default class DeleteTaskModal extends React.Component {
  static propTypes = {
    shown: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
  };

  render() {
    const { shown, onCancel, onDelete } = this.props;

    return (
      <Modal
        className='contact-modal overflow-visible'
        name='task-delete-modal'
        show={shown}
        onHide={onCancel}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Task</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>Are you sure you want to delete this task entirely?</div>
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-sm btn-cancel' onClick={onCancel}>Cancel</button>
          <button
            className='btn btn-sm btn-danger'
            onClick={onDelete}
          >
              Delete
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
